import * as $ from "jquery";

export class Tools {
    public constructor() {
        this.initRegionBonusCalculator();
    }

    private initRegionBonusCalculator() {
        $('#calculator-nr-territories').on('keyup', () => this.calculateRegionBonus());
        $('#calculator-nr-borders').on('keyup', () => this.calculateRegionBonus());
        $('#calculator-button').on('click', () => this.calculateRegionBonus());
    }

    private calculateRegionBonus() {
        const territories = parseInt($('#calculator-nr-territories').val() as string);
        const borders = parseInt($('#calculator-nr-borders').val() as string);
        $('#calculator-answer').val(territories / 3.0 + borders / 2.5);
    }
}
